import styles from "./SiteFooter.module.css";

function SiteFooter() {
  return <div className={styles.wrapper}>SBennett 2024.</div>;
}

export default SiteFooter;
